import React, { Component } from 'react';
import './ReviewApplicants.css';

import * as formatter from 'helpers/Formatter';
import { AccentColor } from 'helpers/AccentColorHelper';
import capitalize from 'capitalize';

class EmploymentInformation extends Component {
  showDurationDates = (startDate, endDate, is_current_occupation) => {
    if (is_current_occupation) {
      return formatter.reformatDate(startDate) + ' to Present';
    }
    return formatter.reformatDate(startDate) + ' to ' + formatter.reformatDate(endDate);
  };

  showAddress = (unit, street) => {
    return (unit ? unit + ' - ' : '') + street;
  };

  render() {
    const style = {
      row: {
        padding: '0 15px',
        marginTop: '30px',
      },
      full_width: {
        width: '100%',
      },
      table_row: {
        width: '50%',
        verticalAlign: 'initial',
      },
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      sub_header_main: {
        marginTop: '20px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      small_font: {
        marginTop: '2px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
      },
      delete_button: {
        padding: '15px 0px 0 0',
        textAlign: 'left',
      },
      position_header: {
        fontSize: '18px',
        color: '#6F6F6F',
        marginTop: '5px',
        marginBottom: 0,
        height: 'initial',
      },
      underline: {
        borderColor: '#fff',
        bottom: 0,
      },
      underline_focus: {
        borderColor: '#f7f7f7',
        bottom: 0,
      },
      secondary_header_form: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
      },
      input_style: {
        height: 'initial',
        color: '#6F6F6F',
      },
      country: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
      },
      date: {
        fontSize: '18px',
        marginTop: '5px',
        marginBottom: 0,
        height: 'initial',
        display: 'inline-flex',
      },
      flat_button: {
        backgroundColor: AccentColor(),
        color: '#fff',
      },
      button_row: {
        padding: '30px 15px 10px 15px',
        textAlign: 'center',
      },
      text_field_date: {
        fontSize: '18px',
        height: '31px',
        width: '110px',
      },
      date_end_style: {
        fontSize: '18px',
        height: '31px',
        width: '110px',
        marginLeft: '8px',
      },
      select_field: {
        fontSize: '14px',
        height: '31px',
        color: '#6F6F6F',
        width: '120px',
        marginTop: '-15px',
      },
      select_field_label: {
        color: '#6F6F6F',
        lineHeight: '42px',
        paddingRight: '35px',
      },
      address_header: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-5px',
        marginBottom: 0,
        height: 'initial',
      },
      text_field_city: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
        width: '110px',
      },
      text_field_postal: {
        fontSize: '14px',
        color: '#6F6F6F',
        marginTop: '-2px',
        marginBottom: 0,
        height: 'initial',
        width: '100px',
        marginLeft: '5px',
      },
      bottom: {
        bottom: 0,
      },
      height_none: {
        height: 'none',
      },
      customContentStyle: {
        maxWidth: '600px',
        width: '95%',
        height: '100%',
      },
      bodyContentStyle: {
        padding: '10px 5px 20px 5px',
        textAlign: 'center',
        overflow: 'auto',
      },
      deletebodyContentStyle: {
        padding: '20px 5px 0px 5px',
        textAlign: 'center',
      },
      button_container: {
        padding: '30px 15px 10px 15px',
        marginTop: '-10px',
        textAlign: 'center',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    const applicant_previous_employement_info = this.props.applicant_data;
    let previous_employments = null;
    if (applicant_previous_employement_info.length !== 0) {
      previous_employments = Object.keys(applicant_previous_employement_info).map(key => (
        <div key={key} className="row" style={style.row}>
          <div className="wrapper">
            {applicant_previous_employement_info[key].is_student && (
              <div>
                <h5 style={style.header}>Student</h5>
                <h5 style={style.sub_header}>
                  {capitalize(
                    `${applicant_previous_employement_info[key]
                      .city}, ${applicant_previous_employement_info[key].country}`
                  )}
                </h5>
                <div className="second">
                  <h5 style={style.header}>
                    {capitalize(applicant_previous_employement_info[key].university)}
                  </h5>
                  <h5 style={style.sub_header}>
                    {' '}
                    {`${applicant_previous_employement_info[key]
                      .degree} ${applicant_previous_employement_info[key].graduation_year}`}
                  </h5>
                </div>
              </div>
            )}

            {!applicant_previous_employement_info[key].is_student && (
              <div>
                <h5 style={style.header}>
                  {capitalize(applicant_previous_employement_info[key].occupation)}
                </h5>
                <h5 style={style.sub_header}>
                  {capitalize(applicant_previous_employement_info[key].company_name)}
                </h5>
                <div className="second">
                  <h5 style={style.header}>
                    {' '}
                    {this.showDurationDates(
                      applicant_previous_employement_info[key].start_date,
                      applicant_previous_employement_info[key].end_date,
                      applicant_previous_employement_info[key].is_current_occupation
                    )}{' '}
                  </h5>
                  <h5 style={style.sub_header}>
                    {' '}
                    {applicant_previous_employement_info[key].salary_range}/year
                  </h5>
                  {applicant_previous_employement_info[key].address && (
                    <span>
                      <h5 style={style.sub_header_main}>
                        {this.showAddress(
                          applicant_previous_employement_info[key].address.unit_number,
                          applicant_previous_employement_info[key].address.street
                        )}
                      </h5>
                      <h5 style={style.small_font}>
                        {' '}
                        {applicant_previous_employement_info[key].address.city +
                          ', ' +
                          applicant_previous_employement_info[key].address.postal_code}
                      </h5>
                      <h5 style={style.small_font}>
                        {' '}
                        {applicant_previous_employement_info[key].address.province +
                          ', ' +
                          applicant_previous_employement_info[key].address.country}
                      </h5>
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      ));
    } else {
      previous_employments = (
        <div className="small-message">
          <small>Waiting for application</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Employment Information </h5>
        </div>

        {previous_employments}
      </div>
    );
  }
}

export default EmploymentInformation;
